import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, className = "", y = 24, testId }) {
  return (
    <motion.div
      className={className}
      data-testid={testId}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
